// removed by extract-text-webpack-plugin
module.exports = {"cont":"TourAuslan__cont___3lOMr","main":"TourAuslan__main___3Howx","item":"TourAuslan__item___2h4im","heroTitle":"TourAuslan__heroTitle___D_xPV","heroYear":"TourAuslan__heroYear___3w0D9","heroRoomNumber":"TourAuslan__heroRoomNumber___1hEbf","enterButton":"TourAuslan__enterButton___rpO31","video":"TourAuslan__video___2wdKu","closeVideo":"TourAuslan__closeVideo___gKXyt"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/TourAuslan/TourAuslan.css
// module id = 758
// module chunks = 0